import { Table } from 'react-bootstrap';
import { Menu } from 'react-bootstrap-typeahead';
import styled from 'styled-components';

export const ContainerWrapper = styled.div`
    padding-top: 20px;
    padding-bottom: 25px;

    .btn-group > .active {
        background-color: #337ab7;
        color: #fff;
    }
`;

export const MenuWrapper = styled(Menu)`
    .dropdown-menu > li > a {
        padding: 0;
    }

    .table > tbody > tr > td {
        text-align: center;
    }
`;

export const TableWrapper = styled(Table)`
    & > tbody > tr > td {
        text-align: center;
    }
`;